module.exports = __webpack_public_path__ + "media/images/method-btc-6192d76f9974b777d468c91faaa6322a.png";